import { useUnit } from 'effector-react';
import { theme } from '@unicorn/bms-theme';
import { SDUI } from '@unicorn/sdui';
import { $pending, $sduiReadonly } from '../../../models/detail-sdui';
import * as Styled from '../styled';
import { Loader } from './loader';

export const SduiForm = ({ ticketsSdui }: { ticketsSdui: SDUI }) => {
  const [sduiReadonly, pending] = useUnit([$sduiReadonly, $pending]);

  return (
    <Styled.Container>
      <Loader />

      {!pending && (
        <ticketsSdui.SduiOutput
          componentsType="material-ui"
          theme={theme}
          readonly={sduiReadonly}
        />
      )}
    </Styled.Container>
  );
};
